// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".backdrops[data-v-041ce694]{width:100%;position:relative;z-index:0;height:46vw}@media(min-width:992px){.backdrops[data-v-041ce694]{height:450px}}@media(max-width:992px)and (min-width:768px){.backdrops[data-v-041ce694]{height:290px}}@media(max-width:768px)and (min-width:480px){.backdrops[data-v-041ce694]{height:240px}}", ""]);
// Exports
module.exports = exports;
